import React, {Component} from "react";
import {timezones, agencyTypes, serviceAreas, languageText} from "../config";
import DataOverview from "../chcomponents/DataOverview";

const tableName = "users";

class Users extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageMode: "loading",
            tableColumns : [
                {
                    dataField: "active",
                    type: "bool",
                    sort: false,
                },
                {
                    dataField: "firstName",
                    sort: true
                },
                {
                    dataField: "lastName",
                    sort: true
                },
                {
                    dataField: "email",
                    sort: true
                },
                {
                    dataField: "address",
                    sort: true
                },
                {
                    dataField: "tools",
                    sort: false,
                }
            ],
            fieldData: [
                {
                    fieldName: "firstName",
                    fieldType: "text",
                    colSize: 3,
                    required: true,
                    requiredMessage: "Organization Name is required!"
                },
                {
                    fieldName: "lastName",
                    fieldType: "text",
                    colSize: 3,
                    required: true,
                    requiredMessage: "Organization Name is required!"
                },
                {
                    fieldName: "active",
                    fieldType: "toggle",
                    colSize: 3
                },

                {
                    fieldName: "password",
                    fieldType: "password",
                    colSize: 2
                },
                {
                    fieldName: "passwordConfirm",
                    fieldType: "password",
                    colSize: 2
                },
                {
                    fieldName: "cellPhone",
                    fieldType: "phone",
                    colSize: 3
                },
                {
                    fieldName: "workPhone",
                    fieldType: "phone",
                    colSize: 3
                },
                {
                    fieldName: "faxPhone",
                    fieldType: "phone",
                    colSize: 3
                },
                {
                    fieldName: "email",
                    fieldType: "email",
                    colSize: 2
                },
                {
                    fieldName: "website",
                    fieldType: "text",
                    colSize: 2
                },
                {
                    fieldName: "photo",
                    fieldType: "image",
                    colSize: 1
                },
                {
                    fieldName: "notes",
                    fieldType: "textarea",
                    colSize: 1
                },
                {
                    fieldName: "timezones",
                    fieldType: "dropdown",
                    dropdownData: timezones,
                    colSize: 2
                },
                {
                    fieldName: "addressRadius",
                    fieldType: "dropdown",
                    dropdownData: serviceAreas,
                    colSize: 2,
                    defaultValue: 25
                },
                {
                    fieldName: "address",
                    fieldType: "geoLocate",
                    colSize: 1
                },
                {
                    fieldName: "addressLatitude",
                    fieldType: "hidden",
                    colSize: 0
                },
                {
                    fieldName: "addressLongitude",
                    fieldType: "hidden",
                    colSize: 0
                },
                {
                    fieldName: "organizationId",
                    fieldType: "hidden",
                    colSize: 0
                },
            ],
            fieldDataDefault: {
                name: '',
                active: true,
                cellPhone: '',
                workPhone: '',
                faxPhone: '',
                email: '',
                website: '',
                notes: '',
                timezones: '',
                agencyType: '',
                serviceArea: '',
                address: '',
                addressLatitude: '',
                addressLongitude: '',
                password:'',
                passwordConfirm: ''
            },
        }
    }
    render() {
        const { tableColumns, fieldData, fieldDataDefault } = this.state;
        const { languageCode } = this.props.auth.user.user;
        return (<DataOverview
            tableName={tableName}
            pageTitle={languageText[languageCode].components[tableName].pageTitle}
            listTitle={languageText[languageCode].components[tableName].listTitle}
            listSubTitle={languageText[languageCode].components[tableName].listSubTitle}
            addTitle={languageText[languageCode].components[tableName].addTitle}
            addSubTitle={languageText[languageCode].components[tableName].addSubTitle}
            editTitle={languageText[languageCode].components[tableName].editTitle}
            editSubTitle={languageText[languageCode].components[tableName].editSubTitle}
            tableColumns={tableColumns}
            fieldData={fieldData}
            fieldDataDefault={fieldDataDefault}
        />);
    }
}
export default Users;
